import { Box, TextField, Typography } from "@mui/material";
import React, { useState } from "react";

const Share = (props: any) => {
  console.log(props);
  const [copied, setCopied] = useState<string>("");

  const handleShareClick = () => {
    navigator.clipboard
      .writeText(window.location.origin + props.link)
      .then(() => {
        setCopied("Copied!");
      })
      .catch((err) => {
        setCopied(err);
      });
    const timer = setTimeout(() => {
      setCopied("");
    }, 2000);
    return () => clearTimeout(timer);
  };

  return (
    <div style={{display:"flex",flexDirection:"column",justifyContent:"center",alignItems:"center",height:"300px"}}>
      <Typography fontSize="1.5rem" gutterBottom>
        Share this course
      </Typography>
      <Box sx={{display:"flex",gap:"10px",width:'100%',alignItems:'center'}}>
      <TextField
        variant="outlined"
        fullWidth
        size="small"
        value={window.location.origin + props.link}
      />
      <Typography onClick={handleShareClick}>{copied !== ""? copied:"Copy"}</Typography> 
      </Box>
      
    </div>
  );
};

export default Share;
